import React, { useEffect, useState } from "react"
import { Col, ControlLabel, FormGroup, HelpBlock } from "react-bootstrap"
import { compose, map, propEq } from "ramda"
import {
  localized,
  localizedF,
  showErrorMessage,
  fetchJson,
  sortByFieldNameCaseInsensitive,
} from "js/includes/common/utils"
import { NinjaResponseError } from "js/includes/common/types"
import Select from "react-select"
import { useMounted } from "js/includes/common/hooks"

const actionOptions = [
  { value: true, label: localizedF("general.start") },
  { value: false, label: localizedF("general.stop") },
]

export default function WindowServices({ onChange, validateForm, validation, values: { start, serviceName } }) {
  const [windowsServiceOptionsItems, setWindowsServiceOptionsItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const mounted = useMounted()

  useEffect(() => {
    const getWindowsServices = async () => {
      try {
        setIsLoading(true)

        const response = await fetchJson("/webapp/winservice")
        if (response.resultCode !== "SUCCESS") {
          throw new NinjaResponseError(response)
        }
        const windowsServiceItems = compose(
          sortByFieldNameCaseInsensitive("label", "ASC"),
          map(p => ({ value: p.serviceName, label: p.displayName })),
        )(response.windowsServices)

        mounted.current && setWindowsServiceOptionsItems(windowsServiceItems)
      } catch (error) {
        showErrorMessage(localized("editors.common.winServicesError"))
        throw error
      } finally {
        mounted.current && setIsLoading(false)
      }
    }
    getWindowsServices()
  }, [mounted, setIsLoading, setWindowsServiceOptionsItems])

  const selectedOption = windowsServiceOptionsItems.find(propEq("value", serviceName))

  return (
    <>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.serviceName === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("editors.policy.actions.service")}
        </Col>
        <Col xs={8}>
          <Select
            {...{
              onBlur: () => {
                validateForm(["serviceName"])
              },
              onChange: selection => onChange("serviceName", selection?.value),
              isClearable: true,
              options: windowsServiceOptionsItems,
              isSearchable: true,
              value: selectedOption || "",
              placeholder: isLoading ? localized("general.loading") : "",
            }}
          />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.serviceName === false && validation.message.serviceName}
          </HelpBlock>
        </Col>
      </FormGroup>
      <FormGroup
        className="m-sm m-b-lg text-align-left"
        validationState={validation.success.start === false ? "error" : null}
      >
        <Col xs={4} componentClass={ControlLabel}>
          {localized("general.action")}
        </Col>
        <Col xs={8}>
          <Select
            {...{
              getOptionLabel: ({ label }) => label(),
              options: actionOptions,
              id: "windowsServiceStartOptions",
              value: actionOptions.find(propEq("value", start)),
              onChange: selection => onChange("start", selection.value),
            }}
          />
          <HelpBlock className="invalid position-absolute m-t-none">
            {validation.success.start === false && validation.message.start}
          </HelpBlock>
        </Col>
      </FormGroup>
    </>
  )
}
